<template>
    <div
        class="d-flex gap-1"
        v-if="row.StationAlias?.Alias != ''"
    >
        <span class="flex-fill text-start">
            <TooltipComp
                v-if="row.DeviceStatus?.OnBattery != null && !row.DeviceStatus?.OnBattery"
                :text="$tm('status.powerconnected')"
            >
                <IconComp
                    icon="fa-plug"
                    family="fa-solid"
                    class="me-1"
                />
            </TooltipComp>
        </span>
        <span
            class="flex-fill text-end"
            style="max-width: 2em"
            v-for="(battery, i) in row.DeviceStatus?.Batteries"
            :key="i"
        >
            <BatteryLevelIcon
                :battery-level="battery.PowerLevel"
                :tooltip="true"
                :active="battery.IsActive"
                :present="battery.IsPresent"
            />
        </span>
    </div>
</template>
<script lang="ts" setup>
import { BatteryLevelIcon, IconComp, TooltipComp } from '@/components';
import { $tm } from '@/locize';
import type { StationDeviceStatus } from '@/objects/generated';

defineProps<{
    row: StationDeviceStatus;
}>();
</script>
